import React from 'react';
import PropTypes from 'prop-types';

import {Avatar, Button, SpaceListItem} from '@momentum-ui/react';
import Timer from '@webex/react-component-timer';
import {
  getTeamColor,
  NOTIFICATIONS_BADGE_MENTION,
  NOTIFICATIONS_BADGE_MUTE,
  NOTIFICATIONS_BADGE_NONE,
  NOTIFICATIONS_BADGE_UNMUTE,
  NOTIFICATIONS_BADGE_UNREAD
} from '@webex/react-component-utils';

import './momentum.scss';

const propTypes = {
  avatarUrl: PropTypes.string,
  badge: PropTypes.string,
  callStartTime: PropTypes.number,
  hasCalling: PropTypes.bool,
  id: PropTypes.string,
  isDecrypting: PropTypes.bool,
  isUnread: PropTypes.bool,
  name: PropTypes.string,
  onCallClick: PropTypes.func,
  onClick: PropTypes.func,
  searchTerm: PropTypes.string,
  teamColor: PropTypes.string,
  teamName: PropTypes.string,
  type: PropTypes.string
};

const defaultProps = {
  avatarUrl: '',
  badge: NOTIFICATIONS_BADGE_NONE,
  callStartTime: undefined,
  hasCalling: false,
  id: '',
  isDecrypting: false,
  isUnread: false,
  name: '',
  onCallClick: () => {},
  onClick: () => {},
  searchTerm: '',
  teamColor: '',
  teamName: '',
  type: ''
};

function SpaceItem({
  avatarUrl,
  badge,
  callStartTime,
  hasCalling,
  id,
  isUnread,
  name,
  onClick,
  onCallClick,
  teamName,
  teamColor,
  type,
  isDecrypting,
  searchTerm
}) {
  function handleClick() {
    return onClick(id);
  }

  function handleCallClick(e) {
    if (type === 'direct' || hasCalling) {
      e.stopPropagation();

      return onCallClick(id);
    }

    return false;
  }

  // Show hover call and join in progress buttons
  const hasCallSupport = hasCalling && typeof onCallClick === 'function';

  const avatarElement = (
    <Avatar
      backgroundColor={teamColor ? getTeamColor(teamColor, false) : '#E0E0E0'}
      isDecrypting={isDecrypting}
      src={avatarUrl}
      title={name}
      type={type === 'group' ? 'group' : ''}
    />
  );
  const subheaderElement = (
    <div style={{color: getTeamColor(teamColor, false)}}>{teamName}</div>
  );
  const joinButton = (
    hasCallSupport && callStartTime &&
    <Button
      ariaLabel="Join Call"
      color="green"
      size={28}
      onClick={handleCallClick}
    >
      {
      callStartTime
      ? <Timer startTime={callStartTime} />
        : <div>Now</div>
      }
    </Button>

  );

  return (
    <SpaceListItem
      childrenLeft={avatarElement}
      childrenRight={joinButton}
      header={name}
      isBold={!searchTerm && !isDecrypting && isUnread}
      isAlertOn={badge === NOTIFICATIONS_BADGE_UNMUTE}
      isUnread={!isDecrypting && badge === NOTIFICATIONS_BADGE_UNREAD}
      isMentioned={badge === NOTIFICATIONS_BADGE_MENTION}
      isMuted={badge === NOTIFICATIONS_BADGE_MUTE}
      isDecrypting={isDecrypting}
      subheader={subheaderElement}
      onClick={handleClick}
      searchTerm={searchTerm}
    />
  );
}

SpaceItem.propTypes = propTypes;
SpaceItem.defaultProps = defaultProps;

export default SpaceItem;
